import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setShowLogoutAlert } from '../../store/auth/actions';
import { clearCookiesAndSessionsAction } from "../../store/auth/actions";

const LogOutAlert = () => {
  const dispatch = useDispatch();
  const showLogoutAlert = useSelector((state) => state.Auth.showLogoutAlert);
  const [ open, setOpen ] = useState(false);

  const handleClose = () => {
    dispatch(setShowLogoutAlert(false));
    dispatch(clearCookiesAndSessionsAction());
  };

  useEffect(() => {
    setOpen(showLogoutAlert);
  }, [showLogoutAlert]);

  return (
    <>
      <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
        <AlertDialogTrigger asChild>
          <button style={{ display: 'none' }}>Open</button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>You have been logged out!</AlertDialogTitle>
            <AlertDialogDescription>
              Please login again
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction onClick={handleClose}>OK</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default LogOutAlert;
